<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-12 16:02:08
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-19 14:36:14
 * @FilePath: \hzs-nutra-wecom-shop\src\views\myTeam\myTeam.vue
 * @Description: 我的团队
-->
<template>
  <div class="page-container">
    <div class="mainContent">
      <!-- 层级(面包屑导航) -->
      <div class="breadcrumb flex flex-wrap align-center">
        <template v-for="(item, index) in state.breadcrumbDepartmentList">
          <span
            :class="item.is_target ? '' : 'disabled'"
            @click="handleBreadcrumbDepartmentNameClick(item, item.is_target)"
          >
            {{ item.name }}
          </span>
          <i
            v-if="index < state.breadcrumbDepartmentList.length - 1"
            class="db icon arrowLeftSingleIcon"
          ></i>
        </template>
      </div>

      <div class="inner">
        <div class="departmentBox flex flex-col">
          <template v-for="(item, index) in state.subDepartmentList">
            <div
              class="departmentName"
              @click="handleDepartmentNameClick(item, item.type == 2)"
            >
              {{ item.name }}
            </div>
            <van-divider
              v-if="index < state.subDepartmentList.length - 1"
            ></van-divider>
          </template>
        </div>

        <van-pull-refresh
          v-if="state.memberList.length"
          v-model="state.isRefresh"
          class="listBox flex-1 ovh"
          @refresh="onRefresh"
        >
          <van-list
            v-model:loading="state.listLoading"
            :finished="state.finished"
            finished-text="没有更多了"
            class="h100 ova"
            @load="onLoad"
          >
            <div
              v-for="item in state.memberList"
              :key="item.id"
              class="memberItem"
            >
              <div class="up flex align-center justify-sb">
                <div class="memberName flex align-center">
                  <span>{{ item.name }}</span>
                  <span v-if="item.status != 1" class="memberStatus">
                    已离职
                  </span>
                </div>
                <div class="positionName">{{ item.position }}</div>
              </div>

              <van-divider></van-divider>

              <div class="down flex align-center justify-sb">
                <div class="phone">
                  <span>联系方式</span>
                  <span>{{ item.phone }}</span>
                </div>
                <div class="edit" @click="goto(item)">编辑</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
        <div v-else class="emptyBox flex align-center justify-sc">
          <van-empty
            :image="emptyCustomerImg"
            image-size="150"
            description="没有该客户？去创建新客户"
          />
        </div>
      </div>
    </div>

    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        color="#DCBB89"
        class="save-btn"
        @click="goto()"
      >
        添加新成员
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import MyTeamApi from "@/utils/api/myTeam";
import emptyCustomerImg from "@/assets/img/customer/emptyCustomer.png";

// --------------------------------------- 变量
const router = useRouter();
let shop_clerk_uuid = undefined;
const state = reactive({
  departmentTree: [],

  // 面包屑导航 部门
  breadcrumbDepartmentList: [],

  // 当前部门的 子部门列表
  subDepartmentList: [],

  memberList: [],

  pagination: {
    page: 1,
    lastPage: 1,
    pageSize: 10,
    lastPageSize: 1,
    total: 0,
  },

  isRefresh: false,
  finished: true,
  listLoading: false,
});
// --------------------------------------- 方法、事件
onMounted(async () => {
  shop_clerk_uuid = localStorage.getItem("shop_clerk_uuid");

  await GroupService.getDepartmentTree();
  await nextTick();
  GroupService.getData();
});

// 下拉刷新回调
const onRefresh = async () => {
  // 重置列表状态
  state.finished = false;
  state.listLoading = true; // 先让 List 进入 loading 状态（或者直接在这里处理）

  state.memberList = [];

  state.pagination.lastPage = state.pagination.page;
  state.pagination.lastPageSize = state.pagination.pageSize;

  state.pagination.page = 1;
  state.pagination.pageSize =
    state.pagination.lastPage * state.pagination.lastPageSize;

  await GroupService.getData();
  await nextTick();
  state.isRefresh = false;
  state.pagination.pageSize = state.pagination.lastPageSize;
  state.listLoading = false;
};

// 上拉加载回调 (由 van-list 触发)
const onLoad = async () => {
  // 如果是刷新过程中触发的 load，则不重复请求
  if (state.isRefresh) {
    state.listLoading = false;
    return;
  }

  if (state.memberList.length < state.pagination.total) {
    state.pagination.page += 1;
    await GroupService.getData();
  }
  state.finished = true;
  state.listLoading = false;
};

function goto(row) {
  let query = {};
  if (row?.uuid) {
    query["id"] = row.uuid;
    query["status"] = row.status;
    query["phone"] = row.phone;
  }
  router.push({
    path: "/operateMember",
    query,
  });
}

// 面包屑导航 点击名称
async function handleBreadcrumbDepartmentNameClick(row, is_target) {
  if (!is_target) return;

  let index = state.breadcrumbDepartmentList.findIndex(
    (v) => v.uuid === row.uuid,
  );
  state.breadcrumbDepartmentList.splice(index + 1);
  state.subDepartmentList = row?.children || [];

  await nextTick();
  GroupService.getData();
}
// 当前部门的所属子部门 点击
async function handleDepartmentNameClick(row, isShop) {
  if (isShop) return;

  state.subDepartmentList = row?.children || [];

  state.breadcrumbDepartmentList.push(row);

  await nextTick();
  GroupService.getData();
}

/**
 * 查找第一个 is_target=true 的节点，并返回其所有父节点（包含自身）
 * @param {Array} tree - 树形数据数组
 * @returns {Array} 父节点数组（从根节点到目标节点），如果没找到返回空数组
 */
function findTargetPath(tree) {
  // 内部递归函数
  // node: 当前节点
  // path: 当前已经走过的路径（父节点们）
  const dfs = (node, path) => {
    // 1. 将当前节点加入路径
    const currentPath = [...path, node];

    // 2. 判断是否是目标
    if (node.is_target === true) {
      return currentPath; // 找到啦，返回完整路径
    }

    // 3. 如果有子节点，继续深入查找
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        const result = dfs(child, currentPath);
        // 如果子树里找到了（result 不为 null），直接向上返回结果
        if (result) {
          return result;
        }
      }
    }

    // 4. 当前分支没找到，返回 null
    return null;
  };

  // 遍历顶层数组（因为传入的可能是一个森林/数组，而不单是一棵树）
  for (const root of tree) {
    const result = dfs(root, []);
    if (result) {
      return result;
    }
  }

  return []; // 没找到
}

// --------------------------------------- 请求
const GroupService = {
  async getDepartmentTree() {
    let res = await MyTeamApi._departmentTree({ shop_clerk_uuid }).catch(
      (err) => {},
    );
    if (res?.code === 200) {
      state.departmentTree = res?.data || [];

      let targetPath = findTargetPath(res?.data || []);
      targetPath.splice(-1);

      state.subDepartmentList =
        targetPath?.[targetPath?.length - 1]?.children || [];
      state.breadcrumbDepartmentList = targetPath;
    }
  },
  async getData() {
    let res = await MyTeamApi._myTeamMember({
      shop_clerk_uuid,
      department_uuid:
        state.breadcrumbDepartmentList?.[
          state.breadcrumbDepartmentList?.length - 1
        ]?.uuid || undefined,
      page: state.pagination.page,
      page_size: state.pagination.pageSize,
    }).catch((err) => {});
    if (res?.code === 200) {
      state.memberList = res?.data || [];
      state.pagination.total = res?.total || res?.cnt || 0;
    }
  },
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    如果没有底部按钮, page-container添加 none_bottom_button 类名

    **** 在 @/scss/common.scss ****
*/

.mainContent {
  padding: 0;

  .icon {
    width: 28px;
    height: 28px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    margin-left: 12px;
    margin-right: 12px;

    &.arrowLeftSingleIcon {
      width: 14px;
      height: 14px;
      background-image: url("@/assets/img/icons/arrowLeftSingle.png");
    }
  }

  .breadcrumb {
    height: 62px;
    padding: 0 18px;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;

    span {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #3bcb84;
      text-align: right;
      font-style: normal;
      text-transform: none;

      text-decoration: underline;

      &.disabled {
        text-decoration: none;
        color: #666666;
      }
    }
  }

  .inner {
    height: calc(100% - 62px);
    padding: 10px 18px;

    .departmentBox:not(:empty) {
      padding: 22px 15px 24px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;

      .departmentName {
        font-family:
          PingFang SC,
          PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }

    .listBox {
      .memberItem {
        height: 110px;
        padding: 18px 11px 17px;
        margin-top: 10px;
        border-radius: 12px 12px 12px 12px;
        background: #ffffff;

        .up {
          height: 25px;
          line-height: 25px;
          padding: 0 12px;

          .memberName {
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;

            .memberStatus {
              width: 50px;
              height: 23px;
              line-height: 23px;
              background: #ffe6e6;
              border-radius: 4px 4px 4px 4px;
              margin-left: 13px;

              font-family:
                PingFang SC,
                PingFang SC;
              font-weight: 500;
              font-size: 13px;
              color: #ff0000;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .positionName {
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }
        .down {
          height: 22px;
          line-height: 22px;
          padding: 0 12px;

          .phone {
            span {
              font-family:
                PingFang SC,
                PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #999999;
              text-align: left;
              font-style: normal;
              text-transform: none;

              &:nth-child(2) {
                color: #666;
              }
            }
          }
          .edit {
            font-family:
              PingFang SC,
              PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ff7123;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
  }
}
</style>
